import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { Address } from '../../../models/address';
import { Check } from '../../../models/check';
import { ToBePaid } from '../../../models/to-be-paid';

import { AlertService } from '../../../services/common/alert.service';
import { ToBePaidService } from '../../../services/accounting/to-be-paid.service';
import { ValidationFunctionsService } from '../../../services/common/validation-functions.service';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-to-be-paid-form',
  templateUrl: './to-be-paid-form.component.html',
  styleUrls: ['./to-be-paid-form.component.css'],
})
export class ToBePaidFormComponent implements OnInit {
  /**
   * TODO: Not in use, check and remove
   * @type {Array<Address>}
   */
  addresses: Array<Address> = [];

  /**
   * Check creation
   */
  check: Check = new Check();

  /**
   * Indicates if check is submitted
   * @type {boolean}
   */
  checkSubmitted: boolean = false;

  /**
   * Indicates if check is submitting
   * @type {boolean}
   */
  checkSubmitting: boolean = false;

  /**
   * Vendor for check
   * @type {any}
   */
  checkVendor: any;

  /**
   * Form type
   * @type {string}
   */
  formOption: string = 'charge';

  /**
   * Default form options
   * @type {any}
   */
  formOptions: any = {
    chart_of_accounts: [],
    statuses: [],
  };

  /**
   * Indicates if form has been submitted
   * @type {boolean}
   */
  formSubmitted: boolean = false;

  /**
   * Indicates if form is being submitted
   * @type {boolean}
   */
  formSubmitting: boolean = false;

  /**
   * Indicates if to be paids are being loaded
   * @type {boolean}
   */
  loadingMatterToBePaids: boolean = false;

  /**
   * Matter selected
   * @type {any}
   */
  matter: any;

  /**
   * List of matters
   * @type {Array<any>}
   */
  matters: Array<any> = [];

  /**
   * List of to be paids of matter
   * @type {Array<any>}
   */
  matterToBePaids: Array<any> = [];

  /**
   * To be paids selected for payment
   * @type {Array<any>}
   */
  selectedForPayment: Array<any> = [];

  /**
   * To be paid object of form
   */
  toBePaid: ToBePaid = new ToBePaid();

  /**
   * Vendor selected
   * @type {any}
   */
  vendor: any;

  /**
   * List of available vendors
   * @type {Array<any>}
   */
  vendors: Array<any> = [];

  /**
   * Constructor
   * @param {AlertService}               private alertService               Service for UI notifications
   * @param {Location}                   private location                   Angular service for location info and functions
   * @param {ToBePaidService}            private toBePaidService            Service to access to be paids controller
   * @param {ActivatedRoute}             private route                      Angular service with current route info and params
   * @param {Router}                     private router                     Angular router service for url related subscriptions and for changing url
   * @param {ValidationFunctionsService} private validationFunctionsService Service to perform validations
   * @param {VendorService}              private vendorService              Service to access vendors controller
   */
  constructor(private alertService: AlertService, private location: Location, private toBePaidService: ToBePaidService, private route: ActivatedRoute, private router: Router, public validationFunctionsService: ValidationFunctionsService, private vendorService: VendorService) {
    this.toBePaidService.getFormOptions().then((response_json) => {
      this.formOptions = response_json;
      this.formOptions.chart_of_accounts = [{}].concat(this.formOptions.chart_of_accounts);
    });
    this.route.params.subscribe((params: Params) => {
      if (params['id'])
        this.toBePaidService.getEditToBePaid(params['id']).then((response_json) => {
          if (response_json) {
            this.toBePaid = new ToBePaid().fromJSON(response_json.to_be_paid);
            this.matter = {
              id: this.toBePaid.matter_id,
              label: response_json.matter_name,
              value: response_json.matter_name,
            };
            this.vendorService.getVendorsByMatter(this.matter.id).then((response_json_second) => {
              this.vendors = response_json_second;
              if (response_json.vendor_id) for (let vendor_obj of this.vendors) if (vendor_obj.id == response_json.vendor_id) this.vendor = vendor_obj;
            });
          }
        });
    });
  }

  // Component lifecycle functions

  /**
   * Called on component initialization
   */
  ngOnInit() {
    let scan_id = this.route.snapshot.queryParams['scan_id'];
    let auto_redirect_rule_id = this.route.snapshot.queryParams['auto_redirect_rule_id'];
    let full_amount = this.route.snapshot.queryParams['full_amount'] || 0;
    if (scan_id && auto_redirect_rule_id) {
      //this.alertService.alert_status_info_overlay('Preparing from scan <i class="fas fa-spinner fa-pulse fa-fw"></i>');
      this.toBePaidService
        .newScanToBePaid(Number(scan_id), Number(auto_redirect_rule_id), Number(full_amount))
        .then((response_json) => {
          this.alertService.alert_status_clear_overlay();
          if (response_json.success) {
            console.log(response_json);
            this.toBePaid = new ToBePaid().fromJSON(response_json.to_be_paid);
            this.toBePaid.status = 'O';
            console.log(this.toBePaid);
            this.onMatterSelect(response_json.matter);
          } else this.alertService.alert_status_danger(`Error - ${response_json.text}`);
        })
        .catch((error) => {
          this.alertService.alert_status_danger('Error preparing to be paid');
          this.alertService.alert_status_clear_overlay();
        });
    }
  }

  // Component functions

  /**
   * Called to go back to previous URL
   */
  goBack() {
    this.location.back();
  }

  /**
   * Returns count of selected matters
   * @return {number} Count of selected matters
   */
  matterSelectedCount(): number {
    let count: number = 0;
    for (let matter of this.matters) if (matter.selected) count += 1;
    return count;
  }

  /**
   * Returns count of selected to be paids
   * @return {number} Count of selected to be paids
   */
  matterToBePaidSelectedCount(): number {
    let count: number = 0;
    for (let matterToBePaid of this.matterToBePaids) if (matterToBePaid.selected) count += 1;
    return count;
  }

  /**
   * Called on matter selection
   * @param {any = null} event Matter autocomplete item
   */
  onMatterSelect(event: any = null) {
    if (event) {
      this.matter = event;
      this.vendorService.getVendorsByMatter(this.matter.id).then((response_json) => {
        this.vendors = [{}];
        if (response_json && response_json.length > 0) for (let vendor of response_json) this.vendors.push(vendor);
        let vendor_set: boolean = false;
        if (this.toBePaid.vendor_id)
          for (let vendorItem of this.vendors)
            if (vendorItem.id == this.toBePaid.vendor_id) {
              this.vendor = vendorItem;
              vendor_set = true;
              break;
            }
        if (vendor_set) {
          this.toBePaid.vendor_id = null;
          this.vendor = null;
        }
      });
    } else {
      this.matterToBePaids = [];
      this.loadingMatterToBePaids = true;
      let scope = this;
      this.toBePaidService
        .getMatterToBePaids(this.check.matter_id)
        .then((response_json) => {
          this.loadingMatterToBePaids = false;
          this.matterToBePaids = response_json;
        })
        .catch(function () {
          scope.loadingMatterToBePaids = false;
        });
    }
  }

  /**
   * Called on vendor selection
   */
  onVendorSelect() {
    if (this.vendor && this.vendor.chart_of_account_id) this.toBePaid.chart_of_account_id = this.vendor.chart_of_account_id;
  }

  /**
   * Reset Form
   */
  resetForm() {
    this.toBePaid = new ToBePaid();
    this.matter = null;
    this.vendor = null;
    this.formOption = 'charge';
  }

  /**
   * Save and start a new to be paid
   */
  saveAndNewToBePaid() {
    this.setToBePaidFields();
    console.log(this.toBePaid, this.toBePaid.valid());
    this.formSubmitted = true;
    if (this.toBePaid.valid()) {
      this.formSubmitting = true;
      let scope = this;
      this.toBePaidService
        .saveToBePaid(this.toBePaid)
        .then((response_json) => {
          this.formSubmitting = false;
          if (this.toBePaid.id) this.alertService.alert_status_success('To be paid updated successfully');
          else this.alertService.alert_status_success('To be paid created successfully');
          //this.resetForm();
        })
        .catch(function () {
          scope.formSubmitting = false;
          scope.alertService.alert_status_danger('Error saving to be paid');
        });
    }
  }

  /**
   * Save to be paid and redirect to to be paids index
   */
  saveToBePaid() {
    if (this.formOption == 'check') {
      this.checkSubmitted = true;
      this.check.amount = this.sumOfPayments();
      if (this.check.valid()) {
        this.checkSubmitting = true;
        let scope = this;
        let selectedToBePaids: Array<any> = [];
        for (let matterToBePaid of this.matterToBePaids) if (matterToBePaid.selected) selectedToBePaids.push(matterToBePaid);
        this.toBePaidService
          .createCheck({
            check: this.check,
            selectedToBePaids: selectedToBePaids,
          })
          .then((response_json) => {
            this.checkSubmitting = false;
            if (response_json.success) {
              this.alertService.alert_status_success(response_json.text);
              this.router.navigateByUrl('/to_be_paids');
            } else this.alertService.alert_status_danger(response_json.text);
          })
          .catch(function () {
            scope.checkSubmitting = false;
            scope.alertService.alert_status_danger('Error creating check');
          });
      }
    } else {
      this.setToBePaidFields();
      console.log('Vendor selected', this.vendor);
      console.log('To be paid selected', this.toBePaid);
      this.formSubmitted = true;
      if (this.toBePaid.valid()) {
        this.formSubmitting = true;
        let scope = this;
        this.toBePaidService
          .saveToBePaid(this.toBePaid)
          .then((response_json) => {
            this.formSubmitting = false;
            if (this.toBePaid.id) this.alertService.alert_status_success('To be paid updated successfully');
            else this.alertService.alert_status_success('To be paid created successfully');
            this.location.back();
          })
          .catch(function () {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error saving to be paid');
          });
      }
    }
  }

  /**
   * Select to be paid for payment
   * @param {[type]} selectMatterToBePaid To be paid to be selected
   */
  selectForPayment(selectMatterToBePaid: any) {
    for (let matterToBePaid of this.matterToBePaids) if (matterToBePaid.id == selectMatterToBePaid.id) return;
    this.selectedForPayment.push(selectMatterToBePaid);
  }

  /**
   * Set fields for to be paid
   */
  setToBePaidFields() {
    if (this.matter) this.toBePaid.matter_id = this.matter.id;
    if (this.vendor) {
      this.toBePaid.vendor_id = this.vendor.id;
      this.toBePaid.contact_id = this.vendor.contact_id;
    }
    if (this.formOption == 'charge') this.toBePaid.bill_type_name = 'charge';
    else if (this.formOption == 'payment') this.toBePaid.bill_type_name = 'payment';
  }

  /**
   * Submit disabled check, TODO: Change this from a HTML attribute usage to be set only once into a variable
   * @return {boolean} Boolean value indicating submit disabled
   */
  submitDisabled(): boolean {
    if (this.formOption == 'check' && this.matterToBePaidSelectedCount() < 1) return true;
    else if (this.formOption == 'check' && this.checkSubmitting) return true;
    else if (this.formSubmitting) return true;
    else return false;
  }

  /**
   * Sum of amounts for payment
   * @return {number} Total amount to pay
   */
  sumOfPayments(): number {
    let sum = 0;
    for (let matterToBePaid of this.matterToBePaids) if (matterToBePaid.selected) sum += matterToBePaid.balance;
    return sum;
  }
}
